var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',{attrs:{"gutter":20}},[_c('a-col',{attrs:{"span":12}},[_c('base-dict-list',{on:{"onSelect":_vm.onSelect}})],1),_c('a-col',{attrs:{"span":12}},[_c('base-dict-item-list',{attrs:{"dict":_vm.dictRecord}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }